import { useEffect, useState } from 'react';
import axios from 'axios';
import { ENDPOINTS } from '../../../Utils/Endpoints';
import { Models } from '../../../Utils/ModelsGeneral';

const EMPTY = {
  idEmpresa: 0,
  idUnidadOrganizacional: '',
  activo: true,
};

export default function EmpresasUnidadesOrgModalTab({
  open,
  mode = 'new',
  data = null,
  onClose,
  onSubmit,
  inline = false,
  existingAssignments = [],
}) {
  const [form, setForm] = useState(EMPTY);
  const [unidadesOptions, setUnidadesOptions] = useState([]);

  // Cargar catálogo de Unidades Organizacionales
  useEffect(() => {
    if (open) {
      axios.get(ENDPOINTS.unidadesOrg)
        .then((res) => {
          let lista = (res.data || []).map(Models.unidadesOrg);

          // Filtrar las que ya existen, EXCEPTO la que estamos editando (si aplica)
          if (existingAssignments && existingAssignments.length > 0) {
            const currentId = (mode === 'edit' && data) ? Number(data.idUnidadOrganizacional) : 0;

            lista = lista.filter(u => {
              // Si es la misma que estamos editando, la dejamos pasar
              if (u.idUnidadOrganizacional === currentId) return true;

              // Si ya existe en la lista de asignaciones, la ocultamos
              const alreadyAssigned = existingAssignments.some(
                assigned => Number(assigned.idUnidadOrganizacional) === Number(u.idUnidadOrganizacional)
              );
              return !alreadyAssigned;
            });
          }

          setUnidadesOptions(lista);
        })
        .catch((e) => console.error('Error cargando unidades', e));
    }
  }, [open, existingAssignments, mode, data]);

  useEffect(() => {
    if (mode === 'edit' && data) {
      setForm({
        idEmpresasUnidadesOrg: data.idEmpresasUnidadesOrg ?? 0,
        idEmpresa: data.idEmpresa ?? 0,
        idUnidadOrganizacional: data.idUnidadOrganizacional ?? '',
        activo: data.activo ?? true,
      });
    } else {
      setForm(EMPTY);
    }
  }, [mode, data]);

  if (!open) return null;

  const handleSubmit = () => {
    if (!form.idUnidadOrganizacional) return;
    onSubmit?.({
      ...form,
      idUnidadOrganizacional: Number(form.idUnidadOrganizacional) || 0,
    }, mode);
  };

  const Header = (
    <div className="roles-topbar" style={{ marginBottom: '0.6rem', paddingRight: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flex: '0 0 auto' }}>
      <h3 className="roles-title" style={{ margin: 0 }}>
        {mode === 'new' ? 'Nueva relación Empresa - Unidad Org.' : 'Editar relación'}
      </h3>
      <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
    </div>
  );

  const Body = (
    <div
      style={{
        paddingLeft: '12%',
        paddingRight: 16,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.8rem',
        overflowY: 'auto',
        flex: '1 1 auto',
        minHeight: 0,
      }}
    >
      <div style={{ gridColumn: '1 / -1' }}>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Unidad Organizacional:</label>
        <br /><br />
        <select
          className="infoField"
          value={form.idUnidadOrganizacional}
          onChange={(e) => setForm((prev) => ({ ...prev, idUnidadOrganizacional: e.target.value }))}
        >
          <option value="">— Selecciona Unidad —</option>
          {unidadesOptions.map((u) => (
            <option key={u.idUnidadOrganizacional} value={u.idUnidadOrganizacional}>
              {u.nombre} ({u.clave})
            </option>
          ))}
        </select>
      </div>
    </div>
  );

  const Footer = (
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '.6rem', marginTop: '.8rem', paddingRight: 16, flex: '0 0 auto' }}>
      <button className="roles-btn" onClick={onClose}>Cancelar</button>
      <button
        className="btn-action"
        onClick={handleSubmit}
        disabled={!form.idUnidadOrganizacional}
      >
        {mode === 'new' ? 'Guardar' : 'Actualizar'}
      </button>
    </div>
  );

  if (inline) {
    return (
      <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        {Header}
        {Body}
        {Footer}
      </div>
    );
  }

  return (
    <div
      className="roles-confirm-overlay"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        zIndex: 1000,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <div
        className="roles-confirm-card"
        style={{
          width: 'min(720px, 96vw)',
          maxHeight: '85vh',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,.25)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {Header}
        {Body}
        {Footer}
      </div>
    </div>
  );
}
